import parrotImage from '@/assets/lendo-parrot.webp';

interface ParrotHelperProps {
  message: string;
}

export const ParrotHelper = ({ message }: ParrotHelperProps) => {
  return (
    <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-8 animate-fade-in">
      <div className="relative">
        <img 
          src={parrotImage} 
          alt="Lendo papegøye" 
          className="w-16 h-16 md:w-24 md:h-24 object-contain"
        />
      </div>
      <div className="flex-1 relative">
        <div className="bg-card border-2 border-primary/20 rounded-2xl rounded-tl-none p-3 md:p-4 shadow-card">
          <p className="text-sm md:text-base text-foreground font-medium">
            {message}
          </p>
        </div>
        <div className="absolute -left-2 top-0 w-0 h-0 border-t-[20px] border-t-transparent border-r-[20px] border-r-card border-b-[0px] border-b-transparent"></div>
      </div>
    </div>
  );
};
